import { api } from './authService';

export const sendInvite = async (data) => {
  const response = await api.post('/admin/account-invites', {
    recipient: data.email,
    role_id: data.role_id,
    expires_at: data.expires_at
  });
  return response.data;
};

export const getInvites = async (params) => {
  const response = await api.get('/admin/account-invites', { params });
  return response.data;
};

export const deleteInvite = async (id) => {
  const response = await api.delete(`/admin/account-invites/${id}`);
  return response.data;
};

export const resendInvite = async (notificationId, forceResend = false) => {
  const response = await api.put(`/notifications/${notificationId}`, {
    force_resend: forceResend
  });
  return response.data;
}; 